'use strict';

angular.module('shiftTraderApp')
  .directive('saTapHoldMenu', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'views/directives/saTapHoldMenu.html',
      scope: {
        isDisabled: '=',
        items: '='
      },
      link: function(scope, elem) {
        scope.state = {
          menuOpen: false
        };

        scope.itemsWithoutFirst = _.where(scope.items, function(item, idx) {
          return idx > 0;
        });

        var isMouseDown;
        var mouseDownTimeout;
        var autoCloseTimeout;

        var mainButton = $(elem).find('.mwp_header_left_button_inner');

        $(mainButton).on('mousedown touchstart', function(event) {
          console.log('mousedown', event);
          event.preventDefault();
          if (!scope.isDisabled) {
            isMouseDown = true;
            mouseDownTimeout = $timeout(function() {
              console.log('$timeout exec', isMouseDown);
              if (isMouseDown) {
                scope.state.menuOpen = true;
                autoCloseTimeout = $timeout(function() {
                  scope.state.menuOpen = false;
                }, 3000);
              }

              mouseDownTimeout = null;
            }, 400);
          }
        });

        $(mainButton).on('mouseup touchend', function(event) {
          console.log('mouseup', isMouseDown, mouseDownTimeout, event);
          event.preventDefault();

          if (!scope.isDisabled) {
            if (isMouseDown && _.isNull(mouseDownTimeout)) {
              console.log('not else');
              isMouseDown = false;
              //scope.state.menuOpen = false;
            } else {
              console.log('else');
              isMouseDown = false;

              if (mouseDownTimeout) {
                scope.items[0].fn();
                $timeout.cancel(mouseDownTimeout);
                scope.state.menuOpen = false;
              }
            }
          }
        });

        scope.callFn = function(index) {
          scope.state.menuOpen = false;
          scope.itemsWithoutFirst[index].fn();
        };
      }
    };
  }]);
